import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import UpsellingForm from 'ui-shared/Forms/UpsellingForm'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const VirtualExperienceUpsellingEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <UpsellingForm
          toolbar={<WithDeleteModalToolbar />}
          relatedProduct="virtuals"
        />
      </Edit>
    </SectionWrapper>
  )
}

export default VirtualExperienceUpsellingEdit
